if ( typeof CartForm !== 'function' ) {

	class CartForm extends HTMLElement {

		constructor(){

			super();
			this.ajaxifyCartItems();

		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');
			const prefix = window.KT_PREFIX || '';

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector(`.${prefix}remove`);

				if ( remove ) {

					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');

					remove.addEventListener('click', (e)=>{

						e.preventDefault();

						this.updateCartQty(item, 0);

					});

				}

				const qty = item.querySelector(`.${prefix}qty`);

				if ( qty ) {

					qty.addEventListener('input', debounce(e=>{

						e.preventDefault();

						e.target.blur();

						this.updateCartQty(
							item,
							parseInt(qty.value)
						);

					}, 500));

					qty.addEventListener('click', (e)=>{

						e.target.select();

					});

				}

			});

		}

		updateCartQty(item, newQty){

			let alert = null;

			const prefix = window.KT_PREFIX || '';

			this.form.classList.add(
				`${prefix}processing`
			);

			if (
				this.querySelector(
					`.${prefix}alert`
				)
			) {

				this.querySelector(
					`.${prefix}alert`
				).remove();

			}

			const body = JSON.stringify({

				line: parseInt(
					item.dataset.line
				),

				quantity: newQty

			});

			fetch(
				KROWN.settings.routes.cart_change_url,
				{

					method: 'POST',

					headers: {
						'Content-Type': 'application/json',
						'Accept': 'application/javascript'
					},

					body

				}
			)

				.then(response => response.json())

				.then(response => {

					if ( response.status == 422 ) {

						// wrong stock logic alert

						alert =
							document.createElement(
								'span'
							);

						alert.classList.add(
							`${prefix}alert`,
							`${prefix}alert--error`
						);

						if (
							typeof response.description ===
							'string'
						) {

							alert.innerHTML =
								response.description;

						} else {

							alert.innerHTML =
								response.message;

						}

						KROWN.functions.eventDispatcher(
							'krown:cart:error',
							{
								error: alert.textContent
							}
						);

					}

					return fetch(
						'?section_id=helper-cart'
					);

				})

				.then(response => response.text())

				.then(text => {

					const sectionInnerHTML =
						new DOMParser()
							.parseFromString(
								text,
								'text/html'
							);

					const sourceCartForm =
						sectionInnerHTML
							.getElementById(
								'AjaxCartForm'
							);

					const sourceCartSubtotal =
						sectionInnerHTML
							.getElementById(
								'AjaxCartSubtotal'
							);

					if (
						! sourceCartForm ||
						! sourceCartSubtotal
					) {

						throw new Error(
							'Cart refresh markup not found.'
						);

					}

					const cartFormInnerHTML =
						sourceCartForm.innerHTML;

					const cartSubtotalInnerHTML =
						sourceCartSubtotal.innerHTML;


					/*
						BRC FIX

						On met à jour uniquement le panier
						qui a déclenché l'action.

						Sur la page /cart, le panier principal
						et le drawer peuvent coexister.

						On évite donc ici :

						document.getElementById('AjaxCartForm')

						qui pourrait cibler le mauvais panier.
					*/

					const cartItems = this;

					cartItems.innerHTML =
						cartFormInnerHTML;

					cartItems.ajaxifyCartItems();

					this.form =
						this.querySelector('form');


					/*
						Mise à jour du compteur panier
						dans le header.
					*/

					const cartCount =
						cartItems.querySelector(
							'[data-cart-count]'
						);

					const cartTotal =
						cartItems.querySelector(
							'[data-cart-total]'
						);

					if ( cartCount ) {

						document
							.querySelectorAll(
								'[data-header-cart-count]'
							)
							.forEach(elm=>{

								elm.textContent =
									cartCount.textContent;

							});

					}

					if ( cartTotal ) {

						document
							.querySelectorAll(
								'[data-header-cart-total]'
							)
							.forEach(elm=>{

								elm.textContent =
									cartTotal.textContent;

							});

					}


					/*
						Affichage éventuel d'une erreur
						de stock.
					*/

					if (
						alert !== null &&
						this.form
					) {

						this.form.prepend(
							alert
						);

					}


					/*
						BRC FIX

						On recherche le sous-total dans
						le même contexte que le panier
						ayant déclenché l'action.

						Cela évite de reconstruire le bouton
						checkout d'un autre panier.
					*/

					let cartContext = null;

					if (
						this.closest(
							'[data-js-site-cart-sidebar]'
						)
					) {

						cartContext =
							this.closest(
								'[data-js-site-cart-sidebar]'
							);

					} else if (
						this.closest('main')
					) {

						cartContext =
							this.closest('main');

					}

					let cartSubtotal = null;

					if ( cartContext ) {

						cartSubtotal =
							cartContext.querySelector(
								'#AjaxCartSubtotal'
							);

					}

					/*
						Fallback uniquement si aucun
						contexte local n'est trouvé.
					*/

					if ( ! cartSubtotal ) {

						const subtotals =
							document.querySelectorAll(
								'#AjaxCartSubtotal'
							);

						if ( subtotals.length === 1 ) {

							cartSubtotal =
								subtotals[0];

						}

					}

					if ( cartSubtotal ) {

						cartSubtotal.innerHTML =
							cartSubtotalInnerHTML;

					}


					/*
						Événement natif du thème.
					*/

					const event =
						new Event(
							'cart-updated'
						);

					this.dispatchEvent(
						event
					);


					/*
						Événement utilisé par les apps
						et autres composants du thème.
					*/

					const updatedItem =
						cartItems.querySelector(
							`[data-js-cart-item][data-line="${item.dataset.line}"]`
						);

					if ( updatedItem ) {

						KROWN.functions.eventDispatcher(
							'krown:cart:update',
							{

								itemKey:
									updatedItem.dataset.id,

								itemQty:
									updatedItem.dataset.qty,

								itemVariantId:
									updatedItem.dataset.variant,

								itemProductId:
									updatedItem.dataset.productId

							}
						);

					}

				})

				.catch(e => {

					console.log(e);

					let alert =
						document.createElement(
							'span'
						);

					alert.classList.add(
						`${prefix}alert`,
						`${prefix}alert--error`
					);

					alert.textContent =
						KROWN.settings.locales
							.cart_general_error;

					if ( this.form ) {

						this.form.prepend(
							alert
						);

					}

				})

				.finally(() => {

					if ( this.form ) {

						this.form.classList.remove(
							`${prefix}processing`
						);

					}

				});

		}

	}


	if (
		typeof customElements.get(
			'cart-form'
		) == 'undefined'
	) {

		customElements.define(
			'cart-form',
			CartForm
		);

	}

}



if (
	typeof CartProductQuantity !==
	'function'
) {

	class CartProductQuantity extends HTMLElement {

		constructor(){

			super();

			this._prefix =
				window.KT_PREFIX || '';

			const minusButton =
				this.querySelector(
					`.${this._prefix}qty-minus`
				);

			const plusButton =
				this.querySelector(
					`.${this._prefix}qty-plus`
				);

			if ( minusButton ) {

				minusButton.addEventListener(
					'click',
					this.changeCartInput.bind(
						this
					)
				);

			}

			if ( plusButton ) {

				plusButton.addEventListener(
					'click',
					this.changeCartInput.bind(
						this
					)
				);

			}

		}


		changeCartInput(event){

			/*
				BRC FIX

				Le clic sur + ou - sert uniquement
				à modifier la quantité.

				Il ne doit jamais soumettre le formulaire
				ni remonter vers un éventuel listener
				de checkout.
			*/

			event.preventDefault();

			event.stopPropagation();


			setTimeout(()=>{

				/*
					On récupère LE cart-form auquel
					appartient réellement le bouton.

					On ne passe plus par :

					document.getElementById('AjaxCartForm')
				*/

				const cartForm =
					this.closest(
						'cart-form'
					);

				const cartItem =
					this.closest(
						'[data-js-cart-item]'
					);

				const qty =
					this.querySelector(
						`.${this._prefix}qty`
					);


				if (
					! cartForm ||
					! cartItem ||
					! qty ||
					typeof cartForm.updateCartQty !==
						'function'
				) {

					return;

				}


				const newQty =
					parseInt(
						qty.value
					);


				if (
					Number.isNaN(
						newQty
					)
				) {

					return;

				}


				cartForm.updateCartQty(
					cartItem,
					newQty
				);

			}, 50);

		}

	}


	if (
		typeof customElements.get(
			'cart-product-quantity'
		) == 'undefined'
	) {

		customElements.define(
			'cart-product-quantity',
			CartProductQuantity
		);

	}

}



// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart =
		(openDrawer = true) => {

			fetch(
				'?section_id=helper-cart'
			)

				.then(
					response =>
						response.text()
				)

				.then(text => {

					const sectionInnerHTML =
						new DOMParser()
							.parseFromString(
								text,
								'text/html'
							);

					const sourceCartForm =
						sectionInnerHTML
							.getElementById(
								'AjaxCartForm'
							);

					const sourceCartSubtotal =
						sectionInnerHTML
							.getElementById(
								'AjaxCartSubtotal'
							);

					if (
						! sourceCartForm ||
						! sourceCartSubtotal
					) {

						return;

					}

					const cartFormInnerHTML =
						sourceCartForm.innerHTML;

					const cartSubtotalInnerHTML =
						sourceCartSubtotal.innerHTML;

					const cartItems =
						document.getElementById(
							'AjaxCartForm'
						);

					if ( ! cartItems ) {

						return;

					}

					cartItems.innerHTML =
						cartFormInnerHTML;

					cartItems.ajaxifyCartItems();


					const cartCount =
						cartItems.querySelector(
							'[data-cart-count]'
						);

					const cartTotal =
						cartItems.querySelector(
							'[data-cart-total]'
						);


					if ( cartCount ) {

						document
							.querySelectorAll(
								'[data-header-cart-count]'
							)
							.forEach(elm=>{

								elm.textContent =
									cartCount.textContent;

							});

					}


					if ( cartTotal ) {

						document
							.querySelectorAll(
								'[data-header-cart-total]'
							)
							.forEach(elm=>{

								elm.textContent =
									cartTotal.textContent;

							});

					}


					const cartSubtotal =
						document.getElementById(
							'AjaxCartSubtotal'
						);

					if ( cartSubtotal ) {

						cartSubtotal.innerHTML =
							cartSubtotalInnerHTML;

					}


					if (
						document.querySelector(
							'[data-js-site-cart-sidebar]'
						) &&
						openDrawer === true
					) {

						document
							.querySelector(
								'[data-js-site-cart-sidebar]'
							)
							.show();

					}


					if (
						document.querySelector(
							'cart-recommendations'
						)
					) {

						document
							.querySelector(
								'cart-recommendations'
							)
							.innerHTML = '';

						document
							.querySelector(
								'cart-recommendations'
							)
							.generateRecommendations();

					}

				});

		};

}



if (
	! customElements.get(
		'cart-note'
	)
) {

	customElements.define(

		'cart-note',

		class CartNote extends HTMLElement {

			constructor(){

				super();

				this.addEventListener(

					'input',

					debounce(event => {

						const body =
							JSON.stringify(
								{
									note:
										event.target.value
								}
							);

						fetch(
							`${KROWN.settings.routes.cart_update_url}`,
							{

								method: 'POST',

								headers: {
									'Content-Type':
										'application/json',
									'Accept':
										'application/javascript'
								},

								body

							}
						);

					}, 150)

				);

			}

		}

	);

}



if (
	! customElements.get(
		'cart-discounts'
	)
) {

	customElements.define(

		'cart-discounts',

		class CartDiscounts extends HTMLElement {

			constructor(){

				super();

				const button =
					this.querySelector(
						'[data-js-discount-submit]'
					);

				this.input =
					this.querySelector(
						'[data-js-discount-input]'
					);

				this.cartSubtotal =
					document.getElementById(
						'AjaxCartSubtotal'
					);

				this.cartDiscountError =
					this.querySelector(
						'[data-js-discount-error]'
					);

				this.discountCodes =
					document.querySelector(
						'[data-js-discount-codes]'
					);

				this._prefix =
					window.KT_PREFIX || '';

				this.loadDiscountButtons();


				if ( button ) {

					button.addEventListener(
						'click',
						(e) => {

							e.preventDefault();

							if (
								this.input &&
								this.input.value.length > 0
							) {

								if (
									this.cartSubtotal
								) {

									this.cartSubtotal
										.classList
										.add(
											`${this._prefix}processing`
										);

								}

								if (
									this.discountCodes
								) {

									this.discountCodes
										.classList
										.add(
											`${this._prefix}processing`
										);

								}


								const existingDiscounts =
									Array.from(
										this.querySelectorAll(
											'[data-js-discount]'
										)
									)
									.map(
										elm =>
											elm.dataset.jsDiscount
									);


								const allDiscounts = [
									...existingDiscounts,
									this.input.value
								];


								const discountString =
									allDiscounts.join(
										','
									);


								const body =
									JSON.stringify(
										{
											discount:
												discountString
										}
									);


								fetch(
									`${KROWN.settings.routes.cart_update_url}`,
									{

										method:
											'POST',

										headers: {
											'Content-Type':
												'application/json',
											'Accept':
												'application/javascript'
										},

										body

									}
								)

									.then(
										response =>
											response.json()
									)

									.then(response => {

										const discountCodes =
											response.discount_codes ||
											[];

										const inputValue =
											this.input.value;

										const matchingCode =
											discountCodes.find(
												code =>
													code.code ===
													inputValue
											);


										if (
											matchingCode
										) {

											if (
												matchingCode.applicable
											) {

												this.handleSuccess();

											} else {

												this.handleError();

											}

										} else {

											this.handleError();

										}

									})

									.catch(error => {

										this.handleError();

										console.log(
											`Error: ${error}`
										);

									});

							}

						}
					);

				}

			}


			handleSuccess(){

				fetch(
					'?section_id=helper-cart'
				)

					.then(
						response =>
							response.text()
					)

					.then(text => {

						const sectionInnerHTML =
							new DOMParser()
								.parseFromString(
									text,
									'text/html'
								);

						const sourceSubtotal =
							sectionInnerHTML
								.getElementById(
									'AjaxCartSubtotal'
								);

						if (
							sourceSubtotal &&
							this.cartSubtotal
						) {

							this.cartSubtotal.innerHTML =
								sourceSubtotal.innerHTML;

							this.cartSubtotal
								.classList
								.remove(
									`${this._prefix}processing`
								);

						}


						if (
							this.cartDiscountError
						) {

							this.cartDiscountError
								.innerHTML = '';

						}


						if (
							sectionInnerHTML
								.querySelector(
									'[data-js-discount-codes]'
								) &&
							this.discountCodes
						) {

							this.discountCodes.innerHTML =
								sectionInnerHTML
									.querySelector(
										'[data-js-discount-codes]'
									)
									.innerHTML;

							this.discountCodes
								.classList
								.remove(
									`${this._prefix}processing`
								);

							this.loadDiscountButtons();

						}


						if ( this.input ) {

							this.input.value = '';

						}

					});

			}


			loadDiscountButtons(){

				this.querySelectorAll(
					'[data-js-discount]'
				)
				.forEach(elm=>{

					if (
						! elm.classList.contains(
							`${this._prefix}enabled`
						)
					) {

						elm.classList.add(
							`${this._prefix}enabled`
						);

						elm.addEventListener(
							'click',
							(e)=>{

								e.preventDefault();


								if (
									this.cartSubtotal
								) {

									this.cartSubtotal
										.classList
										.add(
											`${this._prefix}processing`
										);

								}


								if (
									this.discountCodes
								) {

									this.discountCodes
										.classList
										.add(
											`${this._prefix}processing`
										);

								}


								const discountToRemove =
									elm.dataset
										.jsDiscount;


								const allDiscountElements =
									this.querySelectorAll(
										'[data-js-discount]'
									);


								const allDiscounts =
									Array.from(
										allDiscountElements
									)
									.map(
										el =>
											el.dataset
												.jsDiscount
									);


								const remainingDiscounts =
									allDiscounts.filter(
										discount =>
											discount !==
											discountToRemove
									);


								const body =
									JSON.stringify(
										{
											discount:
												remainingDiscounts
													.join(',')
										}
									);


								fetch(
									`${KROWN.settings.routes.cart_update_url}`,
									{

										method:
											'POST',

										headers: {
											'Content-Type':
												'application/json',
											'Accept':
												'application/javascript'
										},

										body

									}
								)

									.then(() => {

										this.handleSuccess();

									})

									.catch(error => {

										console.error(
											`Error: ${error}`
										);

									});

							}
						);

					}

				});

			}


			handleError(){

				if (
					this.cartSubtotal
				) {

					this.cartSubtotal
						.classList
						.remove(
							`${this._prefix}processing`
						);

				}


				if (
					this.discountCodes
				) {

					this.discountCodes
						.classList
						.remove(
							`${this._prefix}processing`
						);

				}


				if (
					this.cartDiscountError
				) {

					this.cartDiscountError.innerHTML =
						window.KROWN.settings.locales
							.cart_discount_code_error;

				}

			}

		}

	);

}